/**
 * 操作日志
 */
import React from 'react';

import { Select, Row } from 'antd';

import PageLayout from '../../ui/PageLayout';

const columns = [{
  title: '登录用户',
  dataIndex: 'username',
  width: '10%',
}, {
  title: '远程地址',
  dataIndex: 'remoteAddr',
  width: '10%',
}, {
  title: '登录系统',
  dataIndex: 'systemType',
  width: '10%',
  format: { 0: "pc管理后台", 1: "管理端小程序", 2: "商城小程序" }
}, {
  title: '登录时间',
  dataIndex: 'loginTime',
  width: '10%',
}];

class LoginLog extends React.Component {

  state = {
    loadData: '',
    queryData: {},
  }

  onSelect = (key) => {
    let queryData = this.state.queryData;
    queryData["systemType"] = key;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  }

  render() {
    return (
      <PageLayout
        condition={(
          <Row>
            <Select onChange={this.onSelect} allowClear={true} style={{ width: '250px' }}>
              <Select.Option key="0">pc管理后台</Select.Option>
              <Select.Option key="1">管理端小程序</Select.Option>
              <Select.Option key="2">商城小程序</Select.Option>
            </Select>
          </Row>
        )}
        rowKey="id"
        url="/loginLog/findLoginLogPage"
        columns={columns}
        loadData={(func) => { this.setState({ loadData: func }) }}
      >
      </PageLayout>
    )
  }



}

export default LoginLog;